"use strict";
import {http} from '../../../core';
import Config from "../../../app.config";
const RequestService = http.create();


export default {
    //事件经理报表
    //事件转问题的数量 发送时间获取数据
    getEventToPro(params){
        return  RequestService.get('event/event_manager_to_problem',params)
    },
    //客户满意度合格率
    getSatisficationRate(params){
        return RequestService.get('event/event_satisfaction_statistics',params)
    },
    //超出SLA的事件的数量
    getExceedSLA(params){
        return RequestService.get('event/event_sla_statistics',params)
    },
    //事件经理协助处理重大和超SLA事件
    bigEventManager(params){
        return RequestService.get('event/big_event_manager',params)
    },
    //绕过服务台数和补录事件数
    colletAndBypass(params){
        return RequestService.get('event/bypass_supplement',params)
    },
}
